import { useLang, useT } from "../i18n";
import type { Lang } from "../content/landing";

const OPTIONS: Lang[] = ["pl", "en"];

function label(lang: Lang): string {
  return lang.toUpperCase();
}

interface Props {
  compact?: boolean;
  className?: string;
}

export default function LangToggle({ compact = false, className = "" }: Props) {
  const { lang, setLang } = useLang();
  const translate = useT();

  return (
    <div
      className={`inline-flex rounded-xl bg-surface border border-[var(--border-subtle)] p-0.5 ${className}`}
      role="group"
      aria-label={translate("langLabel")}
    >
      {OPTIONS.map((option) => {
        const active = lang === option;
        return (
          <button
            key={option}
            type="button"
            onClick={() => setLang(option)}
            title={label(option)}
            aria-pressed={active}
            className={`inline-flex items-center justify-center rounded-[10px] text-xs font-semibold tracking-wide transition-all ${
              compact ? "h-8 min-w-[2rem] px-1.5" : "h-8 px-2.5"
            } ${
              active
                ? "bg-brand-gradient text-white shadow-glow"
                : "text-muted-foreground hover:text-foreground hover:bg-surface-light"
            }`}
          >
            {label(option)}
          </button>
        );
      })}
    </div>
  );
}
